import React from 'react';
import { Lock, X, CheckCircle } from 'lucide-react';
import { Section, LinkRow, PasswordInput } from '../workersetting/settinghelper/SettingsHelpers';

const PrivacySection = ({
  showChangePw,
  setShowChangePw,
  handleChangePassword,
  pwForm,
  setPwForm,
  pwError,
  pwSuccess,
  pwLoading,
  handlePwSubmit
}) => {
  return (
    <Section title="PRIVACY">
      <LinkRow icon={<Lock size={20} />} iconColor="#0491e1" iconBg="#e8f4fd"
        title="Change Password" subtitle="Update your password"
        onClick={handleChangePassword} active={showChangePw} />

      {showChangePw && (
        <div className="sp-panel">
          <div className="sp-panel-header">
            <span className="sp-panel-title">Change Password</span>
            <button className="sp-panel-close" onClick={() => setShowChangePw(false)}><X size={16} /></button>
          </div>

          {pwSuccess ? (
            <div className="sp-success">
              <CheckCircle size={36} />
              <p>Password changed successfully!</p>
            </div>
          ) : (
            <>
              <div className="sp-fields">
                <div className="sp-field">
                  <label className="sp-label">Current Password</label>
                  <PasswordInput value={pwForm.current} placeholder="Enter current password"
                    onChange={e => setPwForm(p => ({ ...p, current: e.target.value }))} />
                </div>
                <div className="sp-field">
                  <label className="sp-label">New Password</label>
                  <PasswordInput value={pwForm.newPw} placeholder="Enter new password"
                    onChange={e => setPwForm(p => ({ ...p, newPw: e.target.value }))} />
                </div>
                <div className="sp-field">
                  <label className="sp-label">Confirm New Password</label>
                  <PasswordInput value={pwForm.confirm} placeholder="Confirm password"
                    onChange={e => setPwForm(p => ({ ...p, confirm: e.target.value }))} />
                </div>
              </div>
              {pwError && <p className="sp-error">{pwError}</p>}
              <button className={`sp-submit ${pwLoading ? 'sp-submit--loading' : ''}`}
                onClick={handlePwSubmit} disabled={pwLoading}>
                {pwLoading ? <><span className="sp-spinner" /> Updating...</> : 'Update Password'}
              </button>
            </>
          )}
        </div>
      )}
    </Section>
  );
};

export default PrivacySection;